export const environment = {
  production: false,
  API: 'https://bizi-dev-e6dxgrabd6c6h9d5.eastus-01.azurewebsites.net',
  useEduValidator: false,
};
